import { GlobalConfigType } from 'actions'
import { accountTypes } from 'config'
import { store } from 'reducers'
import { fillObject } from 'utils'

import { declarationInputs } from './DeclarationsHmda/constants'

export enum BorrowerSeperator {
  BORROWER = 'borrower',
  CO_BORROWER = 'coBorrower',
  CO_BORROWER2 = 'coBorrower2',
  CO_BORROWER3 = 'coBorrower3',
  CO_BORROWER4 = 'coBorrower4',
  CO_BORROWER5 = 'coBorrower5',
  CO_BORROWER6 = 'coBorrower6',
  CO_BORROWER7 = 'coBorrower7',
}

export const BorrowerSeparatorList = Object.values(BorrowerSeperator)

export const CoBorrowers: Array<string> = BorrowerSeparatorList.filter((v) => v !== BorrowerSeperator.BORROWER)

export const BorrowerLabel = (): Record<string, string> => {
  const { borrower } = store.getState()
  const borrowerSeparators = [
    ...Object.keys(borrower).filter((v) => !!borrower[v].isIncluded),
    ...Object.keys(borrower).filter((v) => !borrower[v].isIncluded),
  ]
  return fillObject(borrowerSeparators, (borrowerSep: any) => `Borrower ${borrowerSeparators.indexOf(borrowerSep) + 1}`)
}

export const AvailableBorrowerLabels = (): Record<string, string> => {
  const { globalConfigReducer } = store.getState()
  const maximumborrower = globalConfigReducer[GlobalConfigType.RulesConfig]?.maximumBorrower || 8
  const borrowerSeparators = Object.values(BorrowerSeperator).slice(0, maximumborrower)
  return fillObject(borrowerSeparators, (borrowerSep: any) => `Borrower ${borrowerSeparators.indexOf(borrowerSep) + 1}`)
}

export const accountTypeWithAllBorrower = (): Record<string, any> => ({ ...accountTypes, ...AvailableBorrowerLabels() })

// No longer used - kept for backwards compatibility
export const excelKeys = [
  'borrower',
  '',
  'declaration',
  '',
  'assets',
  '',
  'liabilities',
  '',
  'tracks',
  'rentalEstates',
  '',
]
export const tableLabels: Record<string, string> = {
  borrower: 'Borrower',
  declaration: 'Declaration & HMDA',
  assets: 'Assets',
  liabilities: 'Liabilities',
  tracks: 'Track Record',
  rentalEstates: 'Real Estate Owned',
}
export const tableHeader: Record<string, string[]> = {
  borrower: [
    'First Name',
    'Middle Name',
    'Last Name',
    'Email',
    'Phone',
    'SSN',
    'DOB',
    'Present Address',
    'Mailing Address',
    'Has Entity Title',
    'Entity Name',
    'Entity Address',
    'State of Entity',
    'Entity Tax ID',
    'Citizenship',
    'Borrower Type',
    'Borrower Position',
    'Ownership Percentage',
    'Title Vesting',
    'Ownership',
    'Owned Rented Years',
    'Former Address',
    'Former Ownership',
    'Former Owned Rented Years',
    'Marital Status',
  ],
  declaration: [
    ...Object.values(declarationInputs).map((input: any) => input.title),
    'Borrower',
    'Information Provided Via',
    'Sex',
    'Sex Completed by',
    'Ethnicity',
    'Ethnicity Completed by',
    'Race',
    'Race Completed by',
  ],
  assets: ['Asset Account Type', 'Asset Institution', 'Asset Account Number', 'Asset Account Balance'],
  liabilities: ['Liability Type', 'Account Type', 'Liability Balance', 'Liability Payment'],
  tracks: [
    'Track Street',
    'Track City',
    'Track State',
    'Track ZIP',
    'Track Property Type',
    'Track Purchase Date',
    'Track Purchase Price',
    'Track Renovation Budget',
    'Track Rental Retained',
    'Track Sold Date',
    'Track Sold Price',
    'Track Title Held in Name',
    'Track % of Ownership',
    'Track Additional Notes',
  ],
  rentalEstates: [
    'REO Street',
    'REO City',
    'REO State',
    'REO ZIP',
    'REO Borrower',
    'REO Held',
    'REO Is Subject Property Address?',
    'REO Current Usage',
    'REO Intended Usage',
    'REO Status',
    'REO Type',
    'REO No Units',
    'REO Present Market Value',
    'REO Gross Rental Income',
    'REO Vacancy Factor',
    'REO Mortgage Payments',
    'REO T&I/HOD Included in Mtg',
    'REO Taxes & Insurance & HOD',
  ],
}

export const borrowerExcelKeys = [
  'firstName',
  'middleName',
  'lastName',
  'email',
  'phone',
  'ssn',
  'dob',
  'presentAddress',
  'mailingAddress',
  'hasEntityTitle',
  'entityTitle',
  'entityAddress',
  'entityState',
  'entityTaxID',
  'residency',
  'borrowerType',
  'borrowerPosition',
  'ownershipPercentage',
  'titleVesting',
  'ownership',
  'ownedRentedYears',
  'formerAddress',
  'formerOwnership',
  'formerOwnedRentedYears',
  'maritalStatus',
  'preferredLanguage',
]

export const hmdaExcelKeys = [
  'isBorrower',
  'informationProvidedVia',
  'sex',
  'sexCompletedBy',
  'ethnicity',
  'ethnicityCompletedBy',
  'race',
  'raceCompletedBy',
]

export const declarationExcelKeys = [...Object.keys(declarationInputs), ...hmdaExcelKeys]
